export { default as treatment1Create } from './treatment1Create.png';
export { default as treatment1Take } from './treatment1Take.png';
export { default as treatment2Create } from './treatment2Create.png';
export { default as treatment2Take } from './treatment2Take.png';
export { default as treatment3Create } from './treatment3Create.png';
export { default as treatment3Take } from './treatment3Take.png';
